exports.list = {
    path: '/outlet',
    name: 'outlet_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/outlet/List.vue"),
}
exports.show = {
    path: '/outlet/show/:id',
    name: 'outlet_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/outlet/Show.vue"),
}